import { render, staticRenderFns } from "./IconCreate.vue?vue&type=template&id=6bc86ebe"
import script from "./IconCreate.vue?vue&type=script&lang=js"
export * from "./IconCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc86ebe')) {
      api.createRecord('6bc86ebe', component.options)
    } else {
      api.reload('6bc86ebe', component.options)
    }
    module.hot.accept("./IconCreate.vue?vue&type=template&id=6bc86ebe", function () {
      api.rerender('6bc86ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/button/IconCreate.vue"
export default component.exports